module.exports = __webpack_public_path__ + "static/media/ls_logo.8d091962.png";